<template>
    <HomeSectionContainer :title="t('settings.interfaceLanguage.title')">
        <template #subtitle>
            <p class="body-small text-ink-muted">
                {{ t("settings.interfaceLanguage.subtitle") }}
            </p>
        </template>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 items-stretch">
            <AccountSetting :error="error">
                <template #label>{{ t("settings.interfaceLanguage.label") }}</template>
                <template #content>
                    <AccountSettingSelect
                        id="s_ui_language"
                        :aria-label="t('settings.interfaceLanguage.selectA11yLabel')"
                        :choices="uiLanguageChoices"
                        :model-value="selectedValue"
                        @update:model-value="onChange" />
                </template>
            </AccountSetting>
        </div>
    </HomeSectionContainer>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import HomeSectionContainer from "~vue/ChatHome/HomeSectionContainer.vue";
import AccountSetting from "~vue/UserProfile/AccountSetting.vue";
import AccountSettingSelect from "~vue/UserProfile/AccountSettingSelect.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { getCookie } from "../../utils";

const { t } = useI18n();

const props = defineProps<{
    uiLanguage: string | null;
    uiLanguageChoices: [string, string, string][];
    error?: string;
    profileEndpoint: string;
    currentPageEndpoint: string;
}>();

// A deliberate English choice is stored as "English" (BRA-1056), but the picker's English option carries the empty value.
const selectedValue = computed(() => (props.uiLanguage === "English" ? "" : (props.uiLanguage ?? "")));

function onChange(value: string) {
    router.post(
        props.profileEndpoint,
        { ui_language: value, detail: "ui_language" },
        {
            errorBag: "account_settings",
            headers: {
                "X-CSRFToken": getCookie("csrftoken") ?? "",
                "X-Inertia-Next": props.currentPageEndpoint,
            },
            preserveScroll: true,
            // "locale" refreshes the shared prop app.js watches to update <html lang> immediately
            // after this save, without a reload (BRA-1045 AC18).
            only: ["user_profile", "errors", "user_details", "locale"],
        },
    );
}
</script>
